import { versions } from "../../services/versions";

class HeaderController
{
    constructor ()
    {
        "ngInject";
    }

    version = `version: ${ versions.version }`;
}

export default HeaderController;



// WEBPACK FOOTER //
// ./client/app/components/header/header.controller.js